
import React, { PropTypes } from 'react';
import CSSModules           from 'react-css-modules';
import { reduxForm }        from 'redux-form';

import style from './style.scss';

import moduleRepository from '../../services/modules';
import formInitialiser  from '../../services/formInitialiser';

import * as moduleListActions from '../../actions/moduleList';
import notifier from '../../services/notifier'

import Button        from '../Button';
import Input         from '../Input';
import InlineError   from '../InlineError';
import InputGroup    from '../InputGroup';
import InputSection  from '../InputSection';
import Label         from '../Label';
import DropzoneButton from '../DropzoneButton';

const FileUpload = props => {
    if (!props.show) return null;

    return (
        <InputGroup className={style['form-input-container']}>
            <Label htmlFor="file-chooser" layout="inline" isRequired="true">
                Choose File
            </Label>

            <div className={style['browser-container']}>
                <DropzoneButton
                    className={style['browse-button']}
                    multiple={false}
                    accept={'.png,.jpg,.jpeg,.gif,.bmp'}
                    onDrop={props.selectFilesToUpload}
                >
                    Browse...
                </DropzoneButton>

                <span className={style['browse-file-name']}>
                    { props.getSelectedFileName() ? props.getSelectedFileName() : props.originalFileName }
                </span>
            </div>
        </InputGroup>
    );
};

class ModuleForm extends React.Component {

    componentDidMount() {
        if(this.props.moduleToEdit && this.props.moduleToEdit.background_image) {
            this.props.fields.background_image.onChange(null);
        }
    }

    _selectFilesToUpload(selectedFiles) {
        const selectedFile = selectedFiles[0];
        this.props.fields.background_image.onChange(selectedFile);
    }

    _getSelectedFileName() {
        const file = this.props.fields.background_image.value;

        return file ? file.name : null;
    }

    _saveModule(params) {

            function saveSuccess() {

                notifier.addNotification({
                    message: this.props.mode === 'add' ? 'Module added successfully' : 'Module updated successfully',
                    level: 'success'
                });
                this.props.submitSuccess();
            }

            function saveFailed(response) {
                notifier.showValidationNotifications(response.data.errors)
            }

            if (this.props.mode === 'edit') {

                moduleRepository.update(params)
                    .then(saveSuccess.bind(this), saveFailed);

            } else {

                moduleRepository.create(params)
                    .then(saveSuccess.bind(this), saveFailed);
            }
    }

    render() {

        const { fields: { name, hex_colour }, handleSubmit, submitting, moduleToEdit, mode } = this.props;

        return (
            <form onSubmit={ handleSubmit(this._saveModule.bind(this)) }>

                <InputSection>
                    <InputGroup>
                        <Label>Category Name</Label>
                        <Input { ...name } errors={ name.error } />
                        <InlineError errors={ name.error } />
                    </InputGroup>

                    <InputGroup className={style['form-input-container']}>
                        <Label>Colour</Label>
                        <input { ...hex_colour } styleName="colour-picker" type="color" />
                        <InlineError errors={ hex_colour.error } />
                    </InputGroup>

                    <FileUpload
                        show={true}
                        selectFilesToUpload={this._selectFilesToUpload.bind(this)}
                        getSelectedFileName={this._getSelectedFileName.bind(this)}
                        originalFileName={moduleToEdit && mode === 'edit' ? moduleToEdit.background_image : null}
                    />
                </InputSection>

                <Button disabled={ submitting }
                        autoWidth="true"
                        theme="success"
                        type="submit">

                    <span>Save</span>

                </Button>

            </form>
        );
    }
}

const reduxFormParams = {
    form: 'module',
    fields: ['id', 'name', 'hex_colour', 'background_image']
};

function mapStateToProps(state) {

    const { overlayMode, defaultForm, moduleToEdit } = state.moduleList;

    return {
        initialValues: formInitialiser.getInitialValues(overlayMode, defaultForm, moduleToEdit),
        mode: overlayMode
    }
}

function mapDispatchToProps(dispatch) {

    return {
        submitSuccess() {
            dispatch(moduleListActions.setModuleOverlayVisibility(false));
            dispatch(moduleListActions.refreshModules());

        }
    };
}

export default reduxForm(reduxFormParams, mapStateToProps, mapDispatchToProps)(CSSModules(ModuleForm, style));


// WEBPACK FOOTER //
// ./components/ModuleForm/index.js